import React, { useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { Grid, AccordionSummary, AccordionDetails } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import Accordion from "@material-ui/core/Accordion";
import Translator from "Languages/Utility/Translator";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { useEffect } from "react";
import { read } from "Helpers/LocalStorage";
import { getGrouhMoshtari } from "Stores/actions";
import { useTranslation } from 'react-i18next';
import showNotify from "Helpers/Notify";
import { FACTOR_RESULT } from "Stores/actionTypes";
import SettingsBasePriceCharge from "./SettingsBasePriceCharge";
import SettingsDiscount from "./SettingsDiscount";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";

export default function SettingsGroupCustomer() {
  const { factorResult, customerGroup, selectedProject} = useSelector((state) => ({
    factorResult: state.factor.factorResult,
    customerGroup: state.customer.customerGroup,
    selectedProject: state.project.selectedProject,
  }));
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    customerGroup: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
  });

  useEffect(() => {
    if(customerGroup && customerGroup.length !== 0) {
      setControls({ customerGroup: { selectItems: customerGroup } });
      if(factorResult.customerGroupChanged) {
        const selected = customerGroup.find(item => item.value === factorResult.customerGroupNewValue);
        setControls({ customerGroup: { value: selected } });
      } else {
        const selected = customerGroup.find(item => item.value === selectedProject.IdGroup)
        if(selected) {
          // createBackData(selected);
          setControls({ customerGroup: { value: selected } });
        } else {
          showNotify({ 
            text: t('customerGroupGetError'),
            customClass: "error"
          });
          // createBackData(customerGroup[0]);
          setControls({ customerGroup: { value: customerGroup[0] } });
        }
      }
    }
  }, [customerGroup]);

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    createBackData(value);
  };

  const createBackData = (data) => {
    const result = {
      ...factorResult,
      ChargePriceFitting: data.ChargeFitting,
      ChargePriceGlass: data.ChargeGlass,
      ChargePriceNet: data.ChargeNet,
      ChargePriceOther: data.ChargeOther,
      ChargePriceProfile: data.ChargeProfile,
      DiscountPriceFitting: data.DiscountFitting,
      DiscountPriceGlass: data.DiscountGlass,
      DiscountPriceNet: data.DiscountNet,
      DiscountPriceOther: data.DiscountOther,
      DiscountPriceProfile: data.DiscountProfile,
      IsPercentChargePriceProfile: true,
      IsPercentChargePriceFitting: true,
      IsPercentChargePriceGlass: true,
      IsPercentChargePriceNet: true,
      IsPercentChargePriceOther: true,
      IsPercentDiscountPriceProfile: true,
      IsPercentDiscountPriceFitting: true,
      IsPercentDiscountPriceGlass: true,
      IsPercentDiscountPriceNet: true,
      IsPercentDiscountPriceOther: true,
      DiscountPrice: 0,
      IsCalcPriceUnit: false,
      customerGroupChanged: true,
      customerGroupNewValue: data.value,
    };
    dispatch({ type: FACTOR_RESULT, factorResult: result });
  }


  return (
    <div className="w-100 px-3 pb-3 mt-4">
      <Grid container spacing={2}>
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <MuiAutoComplete
            options={controls.customerGroup.selectItems}
            label={<Translator id={'customerGroup'} />}
            value={controls.customerGroup.value}
            id={'customerGroup'}
            onChange={autoCompleteHandler}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} className="pb-3">
        <SettingsDiscount />
        <SettingsBasePriceCharge />
      </Grid>
    </div>
  );
}
